import React, { useEffect } from 'react';

import 'instantsearch.css/themes/reset-min.css';
import 'instantsearch.css/themes/algolia-min.css';
import './App.scss';

import find from 'lodash/find';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { appUrlPaths } from './urlUtils';
import { getLanguageFromStorage, languages, removeLanguageInStorage, saveLanguageInStorage } from './storageUtils';

const navLinks = [
  { path: appUrlPaths.bzh, label: 'Brezhoneg', language: languages.bzh },
  { path: appUrlPaths.ja, label: '日本語', language: languages.ja },
  { path: appUrlPaths.it, label: 'Italiano', language: languages.it },
  { path: appUrlPaths.de, label: 'Deutsch', language: languages.de },
];

function App () {


  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const languageFromStorage = getLanguageFromStorage();

    // console.log('*** useEffect', location.pathname, languageFromStorage);

    if (location.pathname === '/') {
      if (!languageFromStorage) {
        // nothing to do stay at home
      } else if (languageFromStorage === languages.bzh) {
        // Default is bzh, clean storage
        removeLanguageInStorage();

      } else {
        const navLinkFromStorage = find(navLinks, { language: languageFromStorage });
        if (navLinkFromStorage) {
          navigate('/' + navLinkFromStorage.path);
        }
      }

    } else { // location.pathname !== '/', ie pathname is '/xxx'

      const languageMaybe = location.pathname.substring(1);
      // console.log('*** languageMaybe', languageMaybe);
      const language = languages[ languageMaybe ];
      if (language) {
        saveLanguageInStorage(language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ location ]);

  return (<>
    <h1 className={'visually-hidden'}>Language search app</h1>
    <div className="App">
      <nav className={'language-chooser'}>
        {navLinks.map((navLink, idx) => (
          <NavLink
            key={idx}
            to={`/${navLink.path}`}
            className={navLink.path === appUrlPaths.bzh && location.pathname === '/' ? 'active' : ''}
          >
            <small>{navLink.label}</small>
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  </>);
}

export default App;
